module.exports = __webpack_public_path__ + "static/img/fengcai1.475698b4.png";